import { Dayjs } from "dayjs";
import { TimeRange } from "./TimeRange";
import { Weekday } from "./Weekday";

export interface BaseSchedule {
    id?: ID;
    name: string;
    type: BaseScheduleType;
    start: Dayjs | string | null;
    end: Dayjs | string | null;
    expiresAt?: Dayjs | string | null;
    days?: Weekday[];
    timeRanges?: TimeRange[];
    repeat: BaseScheduleRepeat;
    dates?: string[]; // Applicable only if `repeat === "custom"`.
    createdAt?: Dayjs;
    updatedAt?: Dayjs;
    createdBy?: { id: ID };
    updatedBy?: { id: ID };
    times?: Array<number | null>;
    _remove?: boolean;
}

export enum BaseScheduleRepeat {
    WEEKLY = "weekly",
    CUSTOM = "custom",
}

export enum BaseScheduleType {
    AVAILABLE = "available",
    UNAVAILABLE = "unavailable",
}
